import _ from 'lodash';

let defaultTitle = '';
const WAIT = 750;

/**
 * Set app title
 * e.g.: Page | Twenty 20 Solutions
 *
 * Throttled to mitigate circumstances where routing is unavoidably rapid
 *
 * @param {string} page If omitted, title will reset to default format
 * @param {boolean} [startCase=false] Whether to startCase the page string
 */
const setTitle = _.throttle((page, startCase) => {
  if (!defaultTitle) {
    defaultTitle = window.document.title;
  }

  window.document.title = page ?
    `${startCase ? _.startCase(page) : page} | ${defaultTitle}` :
    defaultTitle;
}, WAIT);


export {
  setTitle,
};
